import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchFuelSettings,
  type FuelSettingsDoc,
} from '../repositories/fuelPrices.js';

/**
 * F-16: `fuel_settings/{tenantId}` の React Query hook。
 *
 * cache key: `['fuelSettings', tenantId]`
 * - tenantId が null/undefined の間は disabled
 * - doc 無し（null）はデフォルト設定で動作する正常系。使う側は
 *   `normalizeFuelSettings(query.data)`（@kawai/shared）で `FuelSettings` に正規化する
 * - fuelSetSettings Callable の成功後に
 *   `queryClient.invalidateQueries({ queryKey: ['fuelSettings'] })` で再取得
 */
export function useFuelSettings(
  tenantId: string | null | undefined,
): UseQueryResult<FuelSettingsDoc | null, Error> {
  return useQuery({
    queryKey: ['fuelSettings', tenantId],
    queryFn: () => fetchFuelSettings(tenantId as string),
    enabled: !!tenantId,
    staleTime: 30 * 1000,
  });
}
